import {
  FACILITIES_FETCHING,
  FACILITIES_FAILED,
  FACILITIES_SUCCESS,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case FACILITIES_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case FACILITIES_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case FACILITIES_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
